<template>
  <div class="row justify-content-center no-gutters main-mr container-fluid">
    <div class="col-12">
      <div id="boards-section">
        <div class="row mb-3">
          <div class="col d-flex justify-content-between align-items-center">
            <h4 class="mb-0 fw-weight font-24 my-project-font-sm active">
              {{ $resourceString["account.MyTray.Title"] }}
            </h4>

            <a
              v-if="selectedTab !== 'Archived'"
              class="btn btn-primary "
              :href="addTrayHref"
              @click="handleAddTray"
            >
              <span
                class="png-icon bg-light position-relative png-icon-icons-glyph--ko-plus bg-transparent mb-1 mr-2"
                style="width: 25px;height: 25px;"
              ></span>
              <span class="" style="">
                {{ $resourceString["account.MyTray.Button.AddTray"] }}
              </span>
            </a>
            <div v-if="selectedTab === 'Archived' && showComponentpcBoardCard ">
              <a
                class="btn call-to-action-button btn-primary px-0 justify-content-center"
                :class="{ disabled: isDisabled }"
                @click.prevent="handleDeleteTray"
              >
                {{ $resourceString["common.Button.Title.Delete"] }}
              </a>
              <a
                class="btn call-to-action-button btn-primary px-0 justify-content-center ml-lg-3 "
                :class="{ disabled: isDisabled }"
                @click="handleArchiveTray"
              >
                {{ $resourceString["account.MyTray.Button.Reactivate"] }}
              </a>
            </div>
          </div>
        </div>

        <div class="row align-items-center mb-3">
          <div class="col-12 col-xl-7 col-lg-9 col-md-9 col-12 pr-0 pb-2">
            <pc-my-trays-tabs />
          </div>
          <div class="col-12 col-xl-3 col-lg-3 col-md-3 col-12">
            <div
              class="d-flex h-100 align-items-center justify-content-center justify-content-sm-end"
            >
              <pc-layout-button :toggleLayout="toggleLayout" />
            </div>
          </div>
        </div>
        <!-- // search bar  -->
        <div class="row">
          <pc-search :cols="null" />
          <!-- sort by -->
          <pc-sort-by />
        </div>
        <div class="col-lg-12 p-0">
          <pc-board-card
            v-if="showComponentpcBoardCard"
            :layoutToRenderIsSmall="layoutToRenderIsSmall"
            :isAdminMode="isAdmin"
          />
          <pc-board-list-view
            v-if="!showComponentpcBoardCard"
            :isAdminMode="isAdmin"
          />
          <!-- Loader -->
          <pc-load-more v-if="showLoadMore" :load-more="onLoadMore" />
        </div>
      </div>
    </div>
    <modal
      height="650"
      name="share-tray-modal"
      data-html2canvas-ignore="true"
      :adaptive="true"
    >
      <pc-vt-share-tray-modal :userEmail="user.user ? user.user.email : ''"></pc-vt-share-tray-modal>
    </modal>
  </div>
</template>
<script>
import PcMyTraysTabs from "./pc-my-trays-tabs.vue";
import PcLayoutButton from "./pc-layout-button.vue";
import PcSortBy from "./pc-sort-by.vue";
import pcBoardCard from "./pc-board-card.vue";
import pcBoardListView from "./pc-board-list-view.vue";
import { mapActions, mapGetters } from "vuex";
import PcSearch from "./pc-search.vue";
import PcLoadMore from "../common/pc-loading-more.vue";
import PcVtShareTrayModal from "../virtual-tray/pc-vt-share-tray-modal.vue";

export default {
  props: ["isAdmin","user"],
  data() {
    return {
      showComponentpcBoardCard: true,
      layoutToRenderIsSmall: false
    };
  },


  computed: {
    ...mapGetters({
      selectedTab: "myTray/getselectedTabName",
      showLoadMore: "myTray/showLoadMore",
      getSelectedTrayId: "myTray/getSelectedTrayId",
      isFetching: "myTray/getLoader"
    }),
    isDisabled() {
      return this.getSelectedTrayId.length === 0;
    },
    addTrayHref() {
      return `/VirtualTray`;
    }
  },
  mounted() {
    this.updateCommonErrorMsg(this.$resourceString["common.Error.Msg"]);
  },
  methods: {
    ...mapActions({
      deleteVirtualTray: "myTray/deleteVirtualTray",
      archiveVirtualTray: "myTray/archiveVirtualTray",
      loadMoreData: "myTray/loadMoreData",
      modalArchiveMsg: "myTray/modalArchiveMsg",
      startOver: "virtualTray/startOver",
      resourceString: "myTray/resourceString",
      updateCommonErrorMsg:"myTray/updateCommonErrorMsg"

    }),
    handleAddTray() {
      localStorage.removeItem("tray");
    },

    showModal() {
      this.updateModal(true);
    },

    toggleLayout(layoutType) {
      this.layoutToRenderIsSmall = layoutType;
      switch (layoutType) {
        case this.$resourceString["common.LayoutButton.Title.SmallView"]:
          this.layoutToRenderIsSmall = true;
          this.showComponentpcBoardCard = true;
          break;
        case this.$resourceString["common.LayoutButton.Title.LargeView"]:
          this.layoutToRenderIsSmall = false;
          this.showComponentpcBoardCard = true;
          break;
        case this.$resourceString["common.LayoutButton.Title.ListView"]:
          this.layoutToRenderIsSmall = false;
          this.showComponentpcBoardCard = false;
        default:
          this.layoutToRenderIsSmall = false;
      }
    },

    async handleDeleteTray() {
      await this.resourceString(
        this.$resourceString["common.accounts.Deleted.Msg"]
      );
      await this.deleteVirtualTray(this.getSelectedTrayId);
    },
    async handleArchiveTray() {
      await this.modalArchiveMsg(this.$resourceString["common.accounts.Label.Reactivate"]);
      await this.resourceString(
        this.$resourceString["common.accounts.Reactivate.Msg"]
      );
      await this.archiveVirtualTray(this.getSelectedTrayId);
    },
    onLoadMore() {
      if (this.isFetching) {
        return;
      }
      this.loadMoreData();
    }
  },

  components: {
    PcMyTraysTabs,
    PcLayoutButton,
    PcSortBy,
    pcBoardCard,
    pcBoardListView,
    PcSearch,
    PcLoadMore,
    PcVtShareTrayModal
  }
};
</script>
